import React, { useState } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

// УКАЖИ ПРАВИЛЬНЫЙ ПУТЬ К МОДАЛЬНОМУ ОКНУ
import DownloadModal from './WaitlistModal'; // ← проверь, что путь правильный

const Section = styled.section`
  width: 100%;
  background: #000;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
`;

const Title = styled.h2`
  font-size: clamp(2.8rem, 6vw, 4.5rem);
  font-weight: 700;
  margin-bottom: 60px;
  text-align: center;
  opacity: 0.7;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  width: 100%;
  max-width: 1100px;

  @media (min-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 40px 32px;
  backdrop-filter: blur(14px);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  text-align: left;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.1);
  }
`;

const PlanTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 10px;
  font-weight: 600;
`;

const Price = styled.p`
  font-size: 2.6rem;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Description = styled.p`
  opacity: 0.7;
  margin-bottom: 28px;
  font-size: 1.05rem;
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 1rem;
  margin-bottom: 40px;
  padding: 0;
`;

const Line = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0.9;
`;

// ИСПРАВЛЕНО — убран лишний { и правильный синтаксис
const Button = styled.button`
  width: 100%;
  padding: 16px 0;
  background: #fff;
  color: #000;
  border-radius: 14px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s ease;

  &:hover {
    background: #dcdcdc;
  }
`;

export default function PricingSection() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const plans = [
    {
      name: t("plan_free_name"),
      price: t("plan_free_price"),
      desc: t("plan_free_desc"),
      features: t("plan_free_features"),
    },
    {
      name: t("plan_business_name"),
      price: t("plan_business_price"),
      desc: t("plan_business_desc"),
      features: t("plan_business_features"),
    },
    {
      name: t("plan_b2b_name"),
      price: t("plan_b2b_price"),
      desc: t("plan_b2b_desc"),
      features: t("plan_b2b_features"),
    },
  ];

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Section>
          <Title>{t("pricing_title")}</Title>

          <Grid>
            {plans.map((plan, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <Card>
                  <PlanTitle>{plan.name}</PlanTitle>
                  <Price>{plan.price}</Price>
                  <Description>{plan.desc}</Description>

                  <List>
                    {plan.features.split(" · ").map((feature, idx) => (
                      <Line key={idx}>• {feature}</Line>
                    ))}
                  </List>

                  <Button onClick={() => setShowModal(true)}>
                    {t("pricing_button")}
                  </Button>
                </Card>
              </motion.div>
            ))}
          </Grid>
        </Section>
      </motion.div>

      {/* Модальное окно (Waitlist) */}
      {showModal && <DownloadModal onClose={() => setShowModal(false)} />}
    </>
  );
}